import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

/**
 * Vertical colored bar indicating team type
 * Simple inline component - no need for separate file, but keeping it separate for reuse
 */
const TeamTypeBarStyled = styled.div`
  width: 4px;
  height: 20px;
  margin-left: 2px;
  background-color: ${(props) => {
    switch (props.badgeVariant) {
      case "success":
        return props.theme.colors.successLightest;
      case "successPending":
        return props.theme.colors.successEvenLighter;
      case "warning":
        return props.theme.colors.warningLightest;
      case "danger":
        return props.theme.colors.dangerLightest;
      case "primaryLight":
        return props.theme.colors.primaryLightest;
      case "primary":
        return props.theme.colors.primaryLighter;
      case "primaryDark":
        return props.theme.colors.primaryLight;
      case "secondary":
        return props.theme.colors.secondaryEvenLighter;
      default:
        return props.theme.colors.secondary;
    }
  }};
  flex-shrink: 0;
  border-radius: 2px;
`;

const TeamTypeBar = ({ badgeVariant = "default" }) => {
  return <TeamTypeBarStyled badgeVariant={badgeVariant} />;
};

TeamTypeBar.propTypes = {
  badgeVariant: PropTypes.string,
};

export default TeamTypeBar;
